import { sortBy } from "lodash";
import { OPEN_UNLIMITED, PricingTerm } from "types";

/**
 * We need to maintain min, max for tiered Pricing tiers. we are setting only min
 * value from UI. This funciton will loop over all terms and set the max value for
 * each tier
 */
export const updateQuantityInPricingTerms = (pricingTerms: PricingTerm[]) => {
    const sortedTerms = sortBy([...pricingTerms], "quantityMin");
    for (const [index, sortedTerm] of sortedTerms.entries()) {
        if (index === 0) {
            sortedTerm.quantityMin = 1;
        }

        if (index < sortedTerms.length - 1) {
            const nextTermQuantityMin = sortedTerms[index + 1].quantityMin;
            if (nextTermQuantityMin) {
                sortedTerm.quantityMax = nextTermQuantityMin - 1;
            }
        }

        // Since it's the last item we're setting it to the max value
        if (index === sortedTerms.length - 1) {
            sortedTerm.quantityMax = OPEN_UNLIMITED;
        }
    }

    return sortedTerms;
};
